<template>
    <li class="results-cardlist__list-item" data-id="results-list-item">
      <div class="action-promo-card">
        <a :href="href">
          <div class="action-promo-card__top">
            <img
                v-if="item.image_640x360"
                data-sizes="(min-width: 601px) 640px, 100vw"
                :data-src="item.image_640x360"
                :data-srcset="item.image_640x360 + ' 640w, ' + item.image_1120x630 + '1120w,'"
                class=" ls-is-cached lazyloaded"
                :alt="item.image_640x360_alt"
                sizes="(min-width: 601px) 640px, 100vw"
                :srcset="item.image_640x360 + ' 640w, ' + item.image_1120x630 + ' 1120w,'"
                :src="item.image_640x360">

          </div>
          <div class="action-promo-card__bottom u-bg-primary-dark-gradient">
            <h3 class="action-promo-card__title u-primary-title u-primary-title u-type-22 u-type-until-bp-small-20 ">{{ title | strip }}</h3>
            <span class="action-promo-card__cta btn btn--secondary btn--small">
                {{ cta }}
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="8" viewBox="0 0 16 8">
                  <path fill="currentColor" fill-rule="nonzero" d="M75 18L91 22 75 26 77.228 22z" transform="translate(-75 -18)"></path>
                </svg>
              </span>
          </div><!--/.action-promo-card__bottom-->
        </a>
      </div><!--/.action-promo-card-->
    </li>
</template>

<script>
export default {
  name: 'ResultsListCardItem',
  props: ['item'],
  data() {
    return {
    }
  },
  computed: {
    href () {
      if(this.item.path) {
        return this.item.path
      }
      else {
        return this.item.url
      }
    },
    title () {
      // PDFs and other indexed files do not have a path
      return this.item.path ? this.item.title : decodeURIComponent(this.item.url.substring(this.item.url.lastIndexOf('/') + 1));
    },
    cta () {
      return this.item.cta ? this.item.cta : 'Placeholder CTA'; // @TODO remove placeholder
    },
  }
}
</script>
